"use client";

import { useState } from "react";
import { JURISDICTIONS, CATEGORIES } from "@/lib/constants";
import StatsBar from "./StatsBar";
import ArticleCard from "./ArticleCard";

export default function ArchiveView({
  activeJur,
  currentStored,
  archiveFilter,
  setArchiveFilter,
  onClear,
  onToggleRelevance,
}) {
  const [activeCategory, setActiveCategory] = useState(null);
  const jurColor = JURISDICTIONS.find((j) => j.id === activeJur)?.color || "#FF5D31";
  const relevanceFiltered =
    archiveFilter === "relevant"
      ? currentStored.filter((a) => a.classification?.relevant)
      : archiveFilter === "filtered"
        ? currentStored.filter((a) => !a.classification?.relevant)
        : currentStored;
  const archiveArticles = activeCategory
    ? relevanceFiltered.filter((a) => a.classification?.category === activeCategory)
    : relevanceFiltered;

  const sorted = [...archiveArticles].sort(
    (a, b) =>
      (b.ingestedAt || b.date || "").localeCompare(a.ingestedAt || a.date || "")
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: "12px", fontFamily: "var(--font-mono)", color: "#70706E" }}>
          Show:
        </span>
        {["relevant", "all", "filtered"].map((f) => {
          const count =
            f === "relevant"
              ? currentStored.filter((a) => a.classification?.relevant).length
              : f === "filtered"
                ? currentStored.filter((a) => !a.classification?.relevant).length
                : currentStored.length;
          return (
            <button
              key={f}
              onClick={() => setArchiveFilter(f)}
              style={{
                padding: "4px 12px",
                borderRadius: "3px",
                border:
                  archiveFilter === f
                    ? `1.5px solid ${jurColor}`
                    : "1.5px solid #DCD6C7",
                backgroundColor: archiveFilter === f ? `${jurColor}10` : "#fff",
                color: archiveFilter === f ? jurColor : "#999999",
                fontSize: "11px",
                fontFamily: "var(--font-mono)",
                fontWeight: 500,
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              {f} ({count})
            </button>
          );
        })}
        <div style={{ flex: 1 }} />
        <button
          onClick={onClear}
          style={{
            padding: "4px 12px",
            borderRadius: "3px",
            border: "1.5px solid #FFCFC2",
            backgroundColor: "#fff",
            color: "#D65C3B",
            fontSize: "11px",
            fontFamily: "var(--font-mono)",
            cursor: "pointer",
          }}
        >
          Clear data
        </button>
      </div>

      {(() => {
        const categoryCounts = {};
        for (const a of relevanceFiltered) {
          const cat = a.classification?.category;
          if (cat) categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
        }
        const activeCats = Object.entries(CATEGORIES).filter(([key]) => categoryCounts[key]);
        if (activeCats.length === 0) return null;
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "16px",
              flexWrap: "wrap",
            }}
          >
            <span style={{ fontSize: "12px", fontFamily: "var(--font-mono)", color: "#70706E" }}>
              Topic:
            </span>
            <button
              onClick={() => setActiveCategory(null)}
              style={{
                padding: "4px 12px",
                borderRadius: "3px",
                border: activeCategory === null ? `1.5px solid ${jurColor}` : "1.5px solid #DCD6C7",
                backgroundColor: activeCategory === null ? `${jurColor}10` : "#fff",
                color: activeCategory === null ? jurColor : "#999999",
                fontSize: "11px",
                fontFamily: "var(--font-mono)",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              All Topics ({relevanceFiltered.length})
            </button>
            {activeCats.map(([key, { label }]) => (
              <button
                key={key}
                onClick={() => setActiveCategory(key)}
                style={{
                  padding: "4px 12px",
                  borderRadius: "3px",
                  border: activeCategory === key ? `1.5px solid ${jurColor}` : "1.5px solid #DCD6C7",
                  backgroundColor: activeCategory === key ? `${jurColor}10` : "#fff",
                  color: activeCategory === key ? jurColor : "#999999",
                  fontSize: "11px",
                  fontFamily: "var(--font-mono)",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                {label} ({categoryCounts[key]})
              </button>
            ))}
          </div>
        );
      })()}

      {sorted.length > 0 && <StatsBar articles={sorted} />}

      {sorted.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#999999",
            fontSize: "14px",
            fontFamily: "var(--font-serif)",
          }}
        >
          {currentStored.length === 0
            ? "No articles stored yet."
            : "No articles match this filter."}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {sorted.map((art, i) => (
            <div
              key={`${art.url}-${i}`}
              style={{ animation: `fadeUp 0.2s ease ${Math.min(i, 10) * 0.03}s both` }}
            >
              <ArticleCard article={art} onToggleRelevance={onToggleRelevance} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
